<template>
  <div class="box1">
    <!-- <van-list
      ref="vanList"
      :finished="finished"
      :finished-text="finishedText"
      @load="getMore"
      class="wrapper"
    > -->
      <div class="additionalInformation" v-for="(item,index) in dataList" :key="index">
        <div class="information">
          <div class="institutionName">
            <div class="title">机构名称</div>
            <div class="details">{{item.operateOrgName}}</div>
          </div>
          <div class="supplementary">
            <div class="title">补充人</div>
            <div class="details">{{item.operateName}}</div>
          </div>
          <div class="supplementTime">
            <div class="title">补充时间</div>
            <div class="details">{{item.createTime}}&nbsp;&nbsp;&nbsp;&nbsp;</div>
          </div>
          
        </div>
        <div class="text">{{item.supplementContent}}</div>
      </div>
    <!-- </van-list> -->
      <isNoInfo :isNolist='isNolist' class="box"></isNoInfo>
    <!-- <scroll-bottom></scroll-bottom> -->
  </div>
</template>
<script>
    import api from '../../../../service/modules/complaintApis';
    import isNoInfo from '../../../../components/isNoInfo';
    import scrollBottom from './scrollBottom'
    import util from '../../../../utils/common'
    export default {
        components: {
            isNoInfo,
            'scroll-bottom': scrollBottom
        },
        data () {
            return {
                item: util.getJsonLocal('item'), 
                curPage: 1,
                pageSize: 10,
                dataList: [],
                loading: false,
                finished: false,
                finishedText: '没有更多',
                isNolist: false
            };
        },
        created () {
            this.handList();
        },
        methods: {
            handList () {
                let parms = {
                    data:{
                      mainComplainNumber: this.item.mainComplainNumber,
                      type: 'supplementDetails',
                      curPage: this.curPage,
                      pageSize: this.pageSize
                    }
                   
                };
                api.worker.detailInfo(parms).then(res => {
                    if (res.ret === 0) {
                        console.log(6666, res);
                        if (!this.dataList.length) {
                            // this.finished = true
                            this.loading = false
                        }
                        if (res.data) {
                            if (res.data.supplementDetails) {
                                if (res.data.supplementDetails.length > 0) {
                                    this.dataList = res.data.supplementDetails;
                                } else {
                                    this.isNolist = true
                                }
                            } else {
                                this.isNolist = true
                            }
                        } else {
                            this.isNolist = true
                        }
                    }
                });
            },
            getMore () {
                this.curPage++
                this.handList()
            }
        }
    };
</script>
<style lang="less" scoped>
.box1 {
  padding:0 12px 12px 12px;
  font-size: 14px;
  background-color: #fbfbfb;
  box-sizing: border-box;
  min-height: 6.2rem;
  position: relative;
  left: 0;
  top: 0;
  z-index: 2;
  .additionalInformation {
    margin: 0 0 24px 0;
    width: 100%;
    background-color: #fff;
    box-shadow: 0px 5px 10px 5px rgba(0, 0, 0, 0.04);
    padding: 16px;
    .information {
      width: 100%;
      font-size: 14px;
      .institutionName,
      .supplementary,
      .supplementTime {
        display: flex;
        .title {
          width: 60px;
          line-height: 22px;
          color: #999999;
        }
        .details {
          color: #333333;
          margin-left: 12px;
          line-height: 22px;
        }
      }
      .supplementary,
      .supplementTime {
        margin-top: 6px;
      }
    }
      .text {
        width: 100%;
        font-size: 14px;
        color: #333333;
        font-weight: Regular;
        margin-top: 6px;
        line-height: 22px;
        display: flex;
        flex-direction: row;
        white-space: wrap ;
        word-break: break-all;
      }
  }
  /deep/.main {
      .box1{
        margin-top: 100px;
      }
  }
}
</style>
